class CrmShipment {
  constructor(id, shippedAt, carrier, shipMethod,
    trackingNumber, shipmentItems, address, distributionOrigin) {
    this.id = id;
    this.shippedAt = shippedAt;
    this.carrier = carrier;
    this.shipMethod = shipMethod;
    this.trackingNumber = trackingNumber;
    this.shipmentItems = shipmentItems;
    this.address = address;
    this.distributionOrigin = distributionOrigin;
  }

  get shipToDisplay() {
    return `${this.address.city}, ${this.address.state}, ${this.address.country}`;
  }

  get shipFromDisplay() {
    return this.distributionOrigin
      ? `${this.distributionOrigin.shippingAddress.city}, 
      ${this.distributionOrigin.shippingAddress.state}, 
      ${this.distributionOrigin.shippingAddress.countryCode}`
      : '';
  }

  get shipmentItemQuantity() {
    return this.shipmentItems.reduce((acc, curr) => acc + curr.quantity, 0);
  }
}

export default CrmShipment;
